module.exports = __webpack_public_path__ + "static/media/CTLA_2-286w.093551ca.jpg";